
























import {
  Vue,
  Component
} from "@/shared/vuepack";
import { FundingOption } from "@/shared/types";
import Persona from "./Persona.vue";
import Contribution from "./Contribution.vue";
import ElectronicStatementConsent from "./ElectronicStatementConsent.vue";
import { useUserStore } from "@/shared/store/user";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

enum YourHsaSteps {
  None,
  Persona,
  ElectronicStatementConsent,
  Contribution
}

@Component({
  components: {
    Persona,
    Contribution,
    ElectronicStatementConsent
  }
})
export default class YourHsa extends Vue {
  userStore = useUserStore();
  custodianSettingsStore = useCustodianSettingsStore();

  componentIndex = 0;

  YourHsaSteps = YourHsaSteps;

  mounted () {
    // move to the first available step after None
    this.stepComplete();
  }

  get collectStatementPreference () {
    return this.custodianSettingsStore.custodianSupportsUserPreferences;
  }

  get componentsForThisUser () {
    return [
      { allowed: true, step: YourHsaSteps.None }, // avoid conditional logic around the array index
      { allowed: this.collectStatementPreference, step: YourHsaSteps.ElectronicStatementConsent },
      { allowed: true, step: YourHsaSteps.Persona },
      { allowed: this.contributionsAllowed, step: YourHsaSteps.Contribution }
    ];
  }

  get currentStep (): YourHsaSteps {
    return this.componentsForThisUser[this.componentIndex].step;
  }

  get contributionsAllowed (): boolean {
    return !this.userStore.isIndividualAccountType && this.userStore.employeeFundingOption ===
        FundingOption.BendCalculatePull;
  }

  stepComplete (): void {
    const indexOfNextStep = this.componentsForThisUser.findIndex(
        (el, index) => el.allowed && index > this.componentIndex);
    if (indexOfNextStep !== -1) {
      this.componentIndex = indexOfNextStep;
    } else {
      this.$emit("complete");
    }
  }
}
